import { FunctionComponent } from "react";
import { useLocation } from "react-router-dom";
import { PageContainerProps } from "./page-container.types";
import { Header } from "./shared/header";

export const PageContainer: FunctionComponent<PageContainerProps> = ({
  children,
}) => {
  const router = useLocation();

  const validationPath = router.pathname !== "/signin";

  return (
    <div className="min-h-full">
      {validationPath && <Header />}

      <main>
        <div className="mx-auto max-w-7xl py-6 sm:px-6 lg:px-8">{children}</div>
      </main>
    </div>
  );
};
